import { useState, type ReactNode } from 'react';
import { Alert } from 'components/common';
import { analytics, useUser } from 'libs';

interface AIUpgradeBannerProps {
  children: ReactNode;
  isDismissable?: boolean;
}

const AIUpgradeBanner = ({ children, isDismissable = true }: AIUpgradeBannerProps) => {
  const user = useUser();
  const [isOpen, setIsOpen] = useState(true);

  if (
    !user.features.is_pro ||
    !isOpen ||
    user.features.has_past_due_payments ||
    (user.features.is_pro && user.features.show_ai)
  ) {
    return null;
  }

  return (
    <Alert
      isDismissable={isDismissable}
      testId="ai-upgrade-banner"
      variant="primary-light"
      onClose={() => {
        setIsOpen(false);
        analytics.upgrade.bannerHide('AI Assistant');
      }}
    >
      {children}
    </Alert>
  );
};

export default AIUpgradeBanner;
